(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('TopicDetailsController', TopicDetailsController);

    TopicDetailsController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function TopicDetailsController($state, $stateParams, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        
        vm.cancel = cancel;
        
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.isNew = isNew;
        
        activate();

        function activate() {
            var promises = [getItem()];
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

      
        function backToList() {
            $state.go("community.topics");
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === "-1";
        }


        function getItem() {
            var val = $stateParams.id;
            
            if (val === '-1') {
                
                vm.item = {};
                vm.item.ID = -1;
                vm.item.Active = 1;
                common.setAuditInfo(vm.item);
                
                return vm.item;
            }


            return dataservice.getItem("api/Community/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                        common.setAuditInfo(vm.item);
                        common.convertDateStringsToDates(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                       // $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                  //  $state.go('404');
                });
        }


        function save() {
            vm.isSaving = true;
            vm.item.Active = true;
            dataservice.saveItem('api/Community', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
